const MuiButton = {
  root: {
    '&:focus': {
      outline: 'none'
    }
  }
};

export default MuiButton;
